"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var addToCart_1 = require("./addToCart");
var removeFromCart_1 = require("./removeFromCart");
var cartUpdate_1 = require("./cartUpdate");
var miniCartAdd_1 = require("./miniCartAdd");
var miniCartRemove_1 = require("./miniCartRemove");
var miniCartView_1 = require("./miniCartView");
var buyNow_1 = require("./buyNow");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.CommerceInteractionEventNames.AddToCart] = addToCart_1.addToCartCartCreator,
    _a[analytics_layer_1.CommerceInteractionEventNames.RemoveFromCart] = removeFromCart_1.removeFromCartCreator,
    _a[analytics_layer_1.CommerceInteractionEventNames.CartUpdate] = cartUpdate_1.cartUpdateCreator,
    _a[analytics_layer_1.CommerceInteractionEventNames.MiniCartView] = miniCartView_1.miniCartViewCreator,
    _a[analytics_layer_1.CommerceInteractionEventNames.MiniCartAdd] = miniCartAdd_1.miniCartAddCreator,
    _a[analytics_layer_1.CommerceInteractionEventNames.MiniCartRemove] = miniCartRemove_1.miniCartRemoveCreator,
    _a[analytics_layer_1.CommerceInteractionEventNames.BuyNow] = buyNow_1.buyNowCreator,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
